export default __webpack_public_path__ + "static/media/giggl-app-icon.89a44077.jpg";